import * as React from 'react'

import { FORM_CONTROL_CLASS } from '@/components/ui/form-control-styles'
import { cn } from '@/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onWheel, ...props }, ref) => {
    return (
      <input
        type={type}
        onWheel={e => {
          // Prevent the scroll wheel from silently mutating a focused number
          // input (a wheel tick changes the value by one `step`, e.g. 1000 ->
          // 999.97 after 3 ticks at step=0.01). Blur so the page scrolls instead.
          if (type === 'number') e.currentTarget.blur()
          onWheel?.(e)
        }}
        className={cn(
          'flex h-10 w-full rounded-md border px-3 py-2 ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
          FORM_CONTROL_CLASS,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
